import { useEffect } from "react";

/**
 * Gestion automatique des timers de session :
 * - Déclenche une modale d'inactivité
 * - Déclenche une déconnexion automatique après un temps défini
 */
export default function useSessionTimers(
  isAuthenticated: boolean,
  logout: () => void,
  setInactive: (v: boolean) => void
) {
  useEffect(() => {
    if (!isAuthenticated) return;

    const INACTIVITY_WARNING_TIME = 1000 * 60 * 13;
    const AUTO_LOGOUT_TIME = 1000 * 60 * 15;

    let warningTimeout: NodeJS.Timeout;
    let logoutTimeout: NodeJS.Timeout;

    const resetTimers = () => {
      clearTimeout(warningTimeout);
      clearTimeout(logoutTimeout);

      warningTimeout = setTimeout(() => {
        setInactive(true);
      }, INACTIVITY_WARNING_TIME);

      logoutTimeout = setTimeout(() => {
        logout();
      }, AUTO_LOGOUT_TIME);
    };

    const events = ["mousemove", "keydown", "click", "scroll"];
    events.forEach((e) => window.addEventListener(e, resetTimers));

    resetTimers();

    return () => {
      clearTimeout(warningTimeout);
      clearTimeout(logoutTimeout);
      events.forEach((e) => window.removeEventListener(e, resetTimers));
    };
  }, [isAuthenticated, logout, setInactive]);
}
